/* USER ACTIONS ***************************************************************/

import { SUCCESS_SUFFIX, FAIL_SUFFIX, PROGRESS_SUFFIX } from 'util/dataprovider'
import { makeAction } from 'util/reduxhelper'

/* Reset */
export const RESET = 'user/RESET'
export const reset = () => {
  return makeAction(RESET)
}

/* Fetch */
export const FETCH = 'user/FETCH'
export const fetch = () => {
  return makeAction(FETCH)
}
/* automated for convenience @see dataprovider */
export const FETCH_FAIL = FETCH + FAIL_SUFFIX
export const FETCH_SUCCESS = FETCH + SUCCESS_SUFFIX




/* Login */
export const LOGIN = 'user/LOGIN'
export const login = (email, password) => {
  return makeAction(LOGIN, { email, password })
}
/* automated for convenience @see dataprovider */
export const LOGIN_FAIL = LOGIN + FAIL_SUFFIX
export const LOGIN_SUCCESS = LOGIN + SUCCESS_SUFFIX


/* Logout */
export const LOGOUT = 'user/LOGOUT'
export const logout = () => {
  return makeAction(LOGOUT)
}
/* automated for convenience @see dataprovider */
export const LOGOUT_FAIL = LOGOUT + FAIL_SUFFIX
export const LOGOUT_SUCCESS = LOGOUT + SUCCESS_SUFFIX


/* REQUEST PASSWORD RESET TOKEN ***********************************************/

export const REQUEST_PASSWORD_RESET_TOKEN = 'user/REQUEST_PASSWORD_RESET_TOKEN'
export const requestPasswordResetToken = (email) => {
  return makeAction(REQUEST_PASSWORD_RESET_TOKEN, { email })
}
/* automated for convenience @see dataprovider */
export const REQUEST_PASSWORD_RESET_TOKEN_FAIL = REQUEST_PASSWORD_RESET_TOKEN + FAIL_SUFFIX
export const REQUEST_PASSWORD_RESET_TOKEN_SUCCESS = REQUEST_PASSWORD_RESET_TOKEN + SUCCESS_SUFFIX


/* RESET PASSWORD *************************************************************/

export const RESET_PASSWORD = 'user/RESET_PASSWORD'
export const resetPassword = (token, newPassword) => {
  return makeAction(RESET_PASSWORD, { token, newPassword })
}
/* automated for convenience @see dataprovider */
export const RESET_PASSWORD_FAIL = RESET_PASSWORD + FAIL_SUFFIX
export const RESET_PASSWORD_SUCCESS = RESET_PASSWORD + SUCCESS_SUFFIX


/* CHANGE NAME ****************************************************************/

export const SAVE_NAME = 'user/SAVE_NAME'
export const saveName = (name) => {
  return (dispatch, getState) => {
    const surname = getState().user.surname
    dispatch(makeAction(SAVE_NAME, { name, surname }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_NAME_FAIL = SAVE_NAME + FAIL_SUFFIX
export const SAVE_NAME_SUCCESS = SAVE_NAME + SUCCESS_SUFFIX


/* CHANGE SURNAME *************************************************************/

export const SAVE_SURNAME = 'user/SAVE_SURNAME'
export const saveSurname = (surname) => {
  return (dispatch, getState) => {
    const name = getState().user.name
    dispatch(makeAction(SAVE_SURNAME, { name, surname }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_SURNAME_FAIL = SAVE_SURNAME + FAIL_SUFFIX
export const SAVE_SURNAME_SUCCESS = SAVE_SURNAME + SUCCESS_SUFFIX


/* CHANGE PASSWORD ************************************************************/

export const SAVE_PASSWORD = 'user/SAVE_PASSWORD'
export const savePassword = (oldPassword, newPassword) => {
  return makeAction(SAVE_PASSWORD, { oldPassword, newPassword })
}
/* automated for convenience @see dataprovider */
export const SAVE_PASSWORD_FAIL = SAVE_PASSWORD + FAIL_SUFFIX
export const SAVE_PASSWORD_SUCCESS = SAVE_PASSWORD + SUCCESS_SUFFIX

/* ORGANIZATION SCHEDULE ******************************************************/

/* Fetch */
export const FETCH_ORGANIZATION_SCHEDULE = 'user/FETCH_ORGANIZATION_SCHEDULE'
export const fetchOrganizationSchedule = () => {
  return (dispatch, getState) => {
    //console.log("fetchOrganizationSchedule")
    dispatch(makeAction(FETCH_ORGANIZATION_SCHEDULE))
  }
}
/* automated for convenience @see dataprovider */
export const FETCH_ORGANIZATION_SCHEDULE_FAIL = FETCH_ORGANIZATION_SCHEDULE + FAIL_SUFFIX
export const FETCH_ORGANIZATION_SCHEDULE_SUCCESS = FETCH_ORGANIZATION_SCHEDULE + SUCCESS_SUFFIX


export const SAVE_ORGANIZATION_SCHEDULE = 'user/SAVE_ORGANIZATION_SCHEDULE'
export const saveOrganizationSchedule = (value) => {
  return (dispatch, getState) => {
    //console.log("saveOrganizationSchedule")
    dispatch(makeAction(SAVE_ORGANIZATION_SCHEDULE, { schedule: value }))
  }
}
/* automated for convenience @see dataprovider */
export const SAVE_ORGANIZATION_SCHEDULE_FAIL = SAVE_ORGANIZATION_SCHEDULE + FAIL_SUFFIX
export const SAVE_ORGANIZATION_SCHEDULE_SUCCESS = SAVE_ORGANIZATION_SCHEDULE + SUCCESS_SUFFIX



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/user.js